// PaymentOptionCard.jsx
import React from "react";
import './faan.scss';
const PaymentOptionCard = ({ id, label, logoSrc, selected, disabled, onSelect }) => {
  return (
    <button
      type="button"
      className={`payment-option-card ${selected ? "is-selected" : ""} ${
        disabled ? "is-disabled" : ""
      }`}
      onClick={() => !disabled && onSelect?.(id)}
      disabled={disabled}
      aria-pressed={selected}
    >
      <div className="payment-option-card__content">
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={`${label} logo`}
            className="payment-option-card__logo"
          />
        ) : (
          <span className="payment-option-card__label">{label}</span>
        )}
      </div>

      <span className={`payment-option-card__radio ${selected ? "on" : ""}`} />
    </button>
  );
};

export default PaymentOptionCard;
